import { combineReducers, createStore as reduxCreateStore } from 'redux'
import { ContactsOthersReducer } from './contactsOthers/reducer'
import { ContactsLostReducer } from './contactsLost/reducer'
import { MailMagReducer } from './mailmag/reducer'
import { CampaignMailReducer } from './campaignmail/reducer'

const RootReducer = combineReducers({
  contactsOthers: ContactsOthersReducer,
  contactsLost: ContactsLostReducer,
  mailmag: MailMagReducer,
  campaignmail: CampaignMailReducer,
})

export type RootState = ReturnType<typeof RootReducer>

const createStore = () => reduxCreateStore(RootReducer)
export default createStore
